import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, AppointmentPayRateLookup, AppointmentPayRateLookupUpdate } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateAppointmentPayRateLookup(): UseMutationResult<
  AxiosResponse<AppointmentPayRateLookup>,
  AxiosError<ErrorMessage>,
  AppointmentPayRateLookupUpdate
> {
  const queryClient = useQueryClient();

  const updateAppointmentPayRateLookup = (
    payload: AppointmentPayRateLookupUpdate,
  ): Promise<AxiosResponse<AppointmentPayRateLookup>> => {
    return client.put(`appointment-pay-rate-lookups/${payload?.appointmentPayRateLookupId}/`, payload);
  };

  return useMutation(updateAppointmentPayRateLookup, {
    onSuccess: () => {
      queryClient.invalidateQueries(['appointmentPayRateLookups']);
    },
  });
}
